import React from 'react';
import { useTheme } from '../ThemeContext';
import MonthChecklist from './MonthChecklist';
import TaskHelpCard from './TaskHelpCard';

const tax = {
  id: 'tax',
  task_name: 'Review property tax assessment (TRIM notice)',
  due_date: '2026-11-07',
  completed: false,
  task: {
    title: 'Review property tax assessment (TRIM notice)',
    description: 'Read the TRIM notice.',
    category: 'Financial & Administrative',
  },
};

const look = {
  id: 'look',
  task_name: 'Look at the roof from the yard',
  due_date: '2026-11-07',
  completed: false,
  snoozed_until: '2026-12-01',
  task: {
    title: 'Look at the roof from the yard',
    description: 'A short look from the yard is enough.',
    estimated_time: '10 minutes',
    when_to_call_pro: 'Call a pro if a shingle is missing.',
  },
};

export default function TaskHelpPreview() {
  const { colors } = useTheme();
  return (
    <div style={{ background: colors.background, minHeight: '100vh', padding: '1rem', boxSizing: 'border-box' }}>
      <MonthChecklist tasks={[tax, look]} colors={colors} />
      <div style={{ background: colors.surface, border: `1px solid ${colors.border}`, borderRadius: '1rem', padding: '1rem' }}>
        <h2 style={{ margin: '0 0 0.5rem', color: colors.text, fontSize: '1.15rem' }}>Review property tax assessment (TRIM notice)</h2>
        <p style={{ margin: '0.5rem 0', color: colors.textSecondary }}>Read the TRIM notice.</p>
        <TaskHelpCard task={tax} colors={colors} onPhoto={() => {}} />
      </div>
      <div style={{ marginTop: '1rem' }}>
        <div className="app-modal-card" style={{ position: 'relative', background: colors.surface, border: `1px solid ${colors.border}`, borderRadius: '20px' }}>
          <h2 style={{ color: colors.text }}>Not for my home</h2>
          <p style={{ color: colors.textSecondary, marginBottom: '1rem' }}>This chore stays hidden. A short reason helps tune the list.</p>
          <textarea aria-label="Why this is not for your home" defaultValue="" style={{ minHeight: 80, borderRadius: 12, border: '2px solid #59c4c4', color: colors.text, background: colors.surface }} />
          <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1rem' }}>
            <button type="button">Hide this chore</button>
            <button type="button">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
}
